import _ from 'lodash';
import moment from 'moment';

export default formatMessages;

/**
 * @name formatMessages
 * @description Format messages from the API
 * @param {array} messages The collection to group
 * @return {array} Returns an array of formatted messages
 */
function formatMessages(messages) {
  const formattedMessages = [];
  _.each(messages, function(message) {
    const formattedMessage = message;
    formattedMessage.localCreatedDate =
    moment(message.created).format('YYYY-MM-DDTHH:mm:ss');
    formattedMessages.push(formattedMessage);
  });
  return formattedMessages;
}



// WEBPACK FOOTER //
// ./utils/format-messages.js